import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AlertComponent } from '../alert/alert.component';
import { ConfirmSaveComponent } from '../confirm-save/confirm-save.component';
import { DataService } from '../data.service';
import { HttpService } from '../http.service';
import { SavedialogComponent } from '../savedialog/savedialog.component';
import { MainpageComponent } from '../mainpage/mainpage.component';
import { CreateEditPageComponent } from '../create-edit-page/create-edit-page.component';
import { ToggleService } from '../toggle.service';

@Component({
  selector: 'app-finalpopup',
  templateUrl: './finalpopup.component.html',
  styleUrls: ['./finalpopup.component.scss']
})
export class FinalpopupComponent  implements OnInit {
  formgroupdata: any;
  courseFeeData: any;
  akashData: any;
  totalCourseFee: any;
  maxconcession: any;
  orgconcession: any;
  proincentive: any;
  coursestrength: any;
  registrationfee: any;
  console: any;
  courseFee: any;
  accomodationFee: any;
  coachingFee: any;
  akashbooksPrinted: any;
  akashbooksnotprinted: any;
  digitalcontent: any;
  akashtotal: any;
  payload: any;
  response: any;
  status: any;
    constructor(private toggle:ToggleService,@Inject(MAT_DIALOG_DATA) public data: any,private router:Router, private dtservice:DataService,
    private http:HttpService,private dialog:MatDialog,private dialogRef: MatDialogRef<FinalpopupComponent>){}

  ngOnInit(): void {
    console.log(this.data)
    this.formgroupdata=this.data.senddata[0];
    this.courseFeeData=this.data.senddata[1];
    this.akashData=this.data.senddata[2];
    this.totalCourseFee=this.formgroupdata.value.totalCourseFee;
    this.maxconcession=this.formgroupdata.value.maxConcession
    this.orgconcession=this.formgroupdata.value.orgConcession
    this.payload=this.data.senddata[4];
   console.log(this.payload)
    if(this.formgroupdata.value.proincentive=="option1")
    {
      this.proincentive="Yes"
    }
    else{
      this.proincentive="No"
    }
   
    this.coursestrength=this.formgroupdata.value.currentStrength
    this.registrationfee=this.formgroupdata.value.registrationFee
    let sum1=0,sum3=0,sum4=0;
    let sum2=0,sum5=0,sum6=0;
    for(let i=0;i<this.courseFeeData.length;i++)
    {
      if(this.courseFeeData[i].headType=="TUTION_FEE")
      {
        sum1=sum1+Number(this.courseFeeData[i].amount);

      }
      else if(this.courseFeeData[i].headType=="ACCOMMODATION_FEE")
      {
        sum3=sum3+Number(this.courseFeeData[i].amount);
      }
      else if(this.courseFeeData[i].headType=="COACHING_FEE")
      {
        sum4=sum4+Number(this.courseFeeData[i].amount);
      }
    }
    for(let i=0;i<this.akashData.length;i++)
    {
      if(this.akashData[i].headType=="AKASH_BOOKS_PRINTED")
      {
        sum2=sum2+Number(this.akashData[i].amount);

      }
      else if(this.akashData[i].headType=="AKASH_BOOKS_NON_PRINTED")
      {
        sum5=sum5+Number(this.akashData[i].amount);
      }
      else if(this.akashData[i].headType== "DIGITAL_CONTENT")
      {
        sum6=sum6+Number(this.akashData[i].amount);
      }
    }
    this.courseFee=sum1;
    this.accomodationFee=sum3;
    this.coachingFee=sum4;
    this.akashbooksPrinted=sum2;
    this.akashbooksnotprinted=sum5;
    this.digitalcontent=sum6;
    this.akashtotal=this.data.senddata[3].value.akashdata;
    
  }
  save()
  {
    
    const dialogref=this.dialog.open(SavedialogComponent,{
      id:'save'
    })
    dialogref.afterClosed().subscribe(deleteResult => {
  
      if (deleteResult) {
        this.savedata()
        this.dialogRef.close();
        dialogref.close();
        this.dialog.open(ConfirmSaveComponent,{
          id:"savedialog",
        })
      }
    });
 

  }
  savedata()
{
  this.http.savedata(this.payload).subscribe((res: any) => {
    this.status=res.status;
    const data=res.message
    if(res.status=='OK')
    {
    
        this.toggle.toggleComponents()
   
    }
    else{
      this.dialog.open(AlertComponent, {
        width: '800px',
        data: {data}
      });
    }
   
   
    }
 );
 }
 }
 